// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_ysh","cls2":"RelatedPapers-cls2_CLF RelatedPapers-cls1_ysh"};